import { linkDataAssetsAndEntry } from '../../../utils/linkArticleData'
import type { Items } from '../../../utils/types/items'
import type { TypeArticleWithoutUnresolvableLinksResponse } from '@/bb-contentful-types'
type FlattenData = (data: Items[]) => TypeArticleWithoutUnresolvableLinksResponse[]

export const flattenData: FlattenData = (data) => {
  const items = data.map((d) => linkDataAssetsAndEntry(d))

  const result = items ? [].concat(...items) : []

  return result
}
